<template>
  <div class="quotation-confirmation-page">
    <div class="col-md-12 no-padd m-b-lg">
      <div class="b-light bg-white">
        <div class="container">
          <ul class="h5 breadcrumb no-border bg-empty m-b-none m-l-n-sm bg-sub-menu">
            <li>
              <a href="#">การขาย</a>
            </li>
            <li class="active">
              <span class="text-success h4">
                ใบเสนอราคา
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="quotation-content-section">
      <div class="title-text">สรุปข้อมูลใบเสนอราคา</div>

      <Panel class="insured-information-container" title="ข้อมูลของผู้ขอเอาประกันภัย">
        <div class="insured-information">
          <div class="information-name">เลขบัตรประจำตัวประชาชน :</div>
          <div class="information-value">{{ insuredInformation.identityNumber }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">{{ insuredInformation.name }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">วัน/เดือน/ปีเกิด :</div>
          <div class="information-value">{{ insuredInformation.dob }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">อายุ :</div>
          <div class="information-value">{{ insuredInformation.age }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">อีเมล :</div>
          <div class="information-value">{{ insuredInformation.email }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">โทรศัพท์มือถือ :</div>
          <div class="information-value">{{ insuredInformation.mobileTel }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">น้ำหนัก :</div>
          <div class="information-value">{{ insuredInformation.weight }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">ส่วนสูง :</div>
          <div class="information-value">{{ insuredInformation.height }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">เพศ :</div>
          <div class="information-value">{{ insuredInformation.gender }}</div>
        </div>
        <div class="insured-information">
          <div class="information-name">อาชีพ :</div>
          <div class="information-value">{{ insuredInformation.occupation }}</div>
        </div>
      </Panel>

      <Panel class="payer-information-container" title="ข้อมูลส่วนบุคคลของผู้ชำระเบี้ยประกันภัย">
        <div class="payer-information">
          <div class="information-name">เลขบัตรประจำตัวประชาชน :</div>
          <div class="information-value">{{ payerInformation.identityNumber }}</div>
        </div>
        <div class="payer-information">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">{{ payerInformation.name }}</div>
        </div>
        <div class="payer-information">
          <div class="information-name">อีเมล :</div>
          <div class="information-value">{{ payerInformation.email }}</div>
        </div>
        <div class="payer-information">
          <div class="information-name">โทรศัพท์มือถือ :</div>
          <div class="information-value">{{ payerInformation.mobileTel }}</div>
        </div>
      </Panel>

      <Panel class="beneficiary-information-container" title="รายละเอียดผู้รับผลประโยชน์">
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiaryFirstPersonName }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="!isBeneficiaryLegalHeir">
          <div class="information-name">ชื่อ-นามสกุล :</div>
          <div class="information-value">
            {{ beneficiaryInformation.beneficiarySecondPersonName }}
          </div>
        </div>
        <div class="beneficiary-information" v-if="isBeneficiaryLegalHeir">
          <div class="information-name"></div>
          <div class="information-value">
            ทายาทตามกฎหมาย
          </div>
        </div>
      </Panel>

      <Panel class="staff-information-container" title="ข้อมูลผู้เสนอขาย">
        <div class="staff-information">
          <div class="information-name">นำเสนอโดย :</div>
          <div class="information-value">{{ staffInformation.name }}</div>
        </div>
        <div class="staff-information">
          <div class="information-name">เลขที่ใบอนุญาติ :</div>
          <div class="information-value">{{ staffInformation.licenseNumber }}</div>
        </div>
        <div class="staff-information">
          <div class="information-name">ธนาคารทหารไทยธนชาต จำกัด (มหาชน) สาขา :</div>
          <div class="information-value">{{ staffInformation.branchName }}</div>
        </div>
        <div class="staff-information">
          <div class="information-name">วันที่นำเสนอ :</div>
          <div class="information-value">{{ staffInformation.saleDate }}</div>
        </div>
      </Panel>

      <Panel class="insurance-package-information-container" title="ข้อมูลแผนประกันภัยที่เลือก">
        <div class="insurance-package-information">
          <div class="information-name">แผนประกันภัย :</div>
          <div class="information-value">{{ insurancePackageInformation.planName }}</div>
        </div>
        <div class="insurance-package-information">
          <div class="information-name">ส่วนลด Deductible (DD) :</div>
          <div class="information-value">
            DD {{ insurancePackageInformation.deductAmount | formatNumber }} ({{
              insurancePackageInformation.deductDiscount | formatNumber
            }}
            บาท)
          </div>
        </div>
        <div class="insurance-package-information">
          <div class="information-name">ผลประโยชน์เพิ่มเติม :</div>
          <div class="information-value">{{ insurancePackageInformation.coverageCode }}</div>
        </div>
      </Panel>

      <div class="insurance-premium-information">
        <div class="information-name">เบี้ยสุทธิรวมอากร 0.4% หลังหักส่วนลด:</div>
        <div class="information-value">{{ insurancePremiumInformation | formatNumber }} บาท</div>
      </div>

      <div class="quotation-confirmation-button-container">
        <div class="edit-info-button">
          <Button theme="outline" @click.native="editQuotationInformation">แก้ไขข้อมูล</Button>
        </div>
        <div class="submit-info-button">
          <Button @click.native="submitQuotationInformation">ยืนยันข้อมูล</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import moment from 'moment'
import _ from 'lodash'

import Button from '@/components/Button'
import Panel from '@/components/Panel'
import { DATE_FORMAT } from '@/lib/global'

const { mapFields: mapQuotationFields } = createHelpers({
  getterType: 'getQuotationFields',
  mutationType: 'updateQuotationFields',
})

export default {
  name: 'QuotationConfirmation',
  props: ['quotation_id'],
  components: {
    Button,
    Panel,
  },
  computed: {
    ...mapQuotationFields({
      quotationInformation: 'quotationInformation.data',
      insuredCustomerInformation: 'insuredDetail.data.customerInformation',
    }),
    insuredInformation() {
      const identityNumber = _.get(this.quotationInformation, 'insuredPerson.identityNumber')
      const namePrefix = _.get(this.quotationInformation, 'insuredPerson.title.name') || ''
      const firstname = _.get(this.quotationInformation, 'insuredPerson.firstname') || ''
      const lastname = _.get(this.quotationInformation, 'insuredPerson.lastname') || ''
      const dob = _.get(this.insuredCustomerInformation, 'dob')
      const age = _.get(this.insuredCustomerInformation, 'age')
      const email = _.get(this.quotationInformation, 'insuredPerson.email')
      const mobileTel = _.get(this.quotationInformation, 'insuredPerson.mainMobileTel')
      const weight = _.get(this.quotationInformation, 'insuredPerson.weight')
      const height = _.get(this.quotationInformation, 'insuredPerson.height')
      const gender = _.get(this.quotationInformation, 'insuredPerson.sex') === 'M' ? 'ชาย' : 'หญิง'
      const occupation = _.get(this.quotationInformation, 'insuredPerson.occupation.nameTh')

      return {
        name: `${namePrefix}${firstname} ${lastname}`.trim(),
        identityNumber,
        dob,
        age,
        email,
        mobileTel,
        weight,
        height,
        gender,
        occupation,
      }
    },
    payerInformation() {
      const identityNumber = _.get(this.quotationInformation, 'payer.identityNumber')
      const namePrefix = _.get(this.quotationInformation, 'payer.title.name') || ''
      const firstname = _.get(this.quotationInformation, 'payer.firstname') || ''
      const lastname = _.get(this.quotationInformation, 'payer.lastname') || ''
      const email = _.get(this.quotationInformation, 'payer.email')
      const mobileTel = _.get(this.quotationInformation, 'payer.mainMobileTel')

      return {
        name: `${namePrefix}${firstname} ${lastname}`.trim(),
        identityNumber,
        email,
        mobileTel,
      }
    },
    beneficiaryInformation() {
      // beneficiary first person information
      const firstPersonNamePrefix =
        _.get(this.quotationInformation, 'beneficiaryPerson1.title.name') || ''
      const firstPersonFirstname =
        _.get(this.quotationInformation, 'beneficiaryPerson1.firstname') || ''
      const firstPersonLastname =
        _.get(this.quotationInformation, 'beneficiaryPerson1.lastname') || ''

      // beneficiary second person information
      const secondPersonNamePrefix =
        _.get(this.quotationInformation, 'beneficiaryPerson2.title.name') || ''
      const secondPersonFirstname =
        _.get(this.quotationInformation, 'beneficiaryPerson2.firstname') || ''
      const secondPersonLastname =
        _.get(this.quotationInformation, 'beneficiaryPerson2.lastname') || ''

      return {
        beneficiaryFirstPersonName: `${firstPersonNamePrefix}${firstPersonFirstname} ${firstPersonLastname}`.trim(),
        beneficiarySecondPersonName: `${secondPersonNamePrefix}${secondPersonFirstname} ${secondPersonLastname}`.trim(),
      }
    },
    staffInformation() {
      const namePrefix = _.get(this.quotationInformation, 'broker.title') || ''
      const firstname = _.get(this.quotationInformation, 'broker.firstname') || ''
      const lastname = _.get(this.quotationInformation, 'broker.lastname') || ''
      const licenseNumber = _.get(this.quotationInformation, 'broker.licenseNumber')
      const branchName = _.get(this.quotationInformation, 'broker.branchName')
      const saleDate = moment()
        .add(543, 'years')
        .format(DATE_FORMAT)

      return {
        name: `${namePrefix}${firstname} ${lastname}`.trim(),
        licenseNumber,
        branchName,
        saleDate,
      }
    },
    insurancePackageInformation() {
      const planName = _.get(this.quotationInformation, 'planPackageScheme.planName')
      const deductAmount = _.get(this.quotationInformation, 'deductible.deduct', 0)
      const deductDiscount = _.get(this.quotationInformation, 'deductible.discount', 0)
      const coverageCode = _.chain(this.quotationInformation)
        .get('planPackageScheme.coverageCode')
        .replace(/\+/g, ', ')
        .value()

      return {
        planName,
        deductAmount,
        deductDiscount,
        coverageCode,
      }
    },
    insurancePremiumInformation() {
      return _.get(this.quotationInformation, 'pricing.netPremium', 0)
    },
    isBeneficiaryLegalHeir() {
      return _.get(this.quotationInformation, 'quotation.isBeneficiaryLegalHeir', false)
    },
  },
  mounted() {
    if (this.quotation_id) {
      this.getQuotationInformation(this.quotation_id)
    }
  },
  methods: {
    ...mapActions(['getQuotationInformation', 'updateQuotationCompleteStatus']),
    editQuotationInformation() {
      const isFamily = _.get(this.quotationInformation, 'familyQuotation.familyId')

      if (isFamily) {
        return this.$router.push(`/quotation_family/${this.quotation_id}`)
      }

      return this.$router.push(`/quotation_personal/${this.quotation_id}`)
    },
    submitQuotationInformation() {
      this.updateQuotationCompleteStatus(this.quotation_id)
    },
  },
}
</script>

<style lang="scss">
.quotation-confirmation-page {
  margin: 0 auto;
  width: 90%;

  .quotation-content-section {
    margin: 32px 0;

    .title-text {
      font-family: 'psl_kanda_extraregular';
      font-size: 20px;
      line-height: 24px;
      margin-bottom: 24px;
      text-align: center;
    }

    .insured-information-container,
    .payer-information-container,
    .beneficiary-information-container,
    .staff-information-container,
    .insurance-package-information-container {
      margin-bottom: 32px;

      .panel-body {
        padding: 24px 24px 32px;
      }

      .information-name {
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }

      .information-value {
        font-family: 'psl_kanda_extraregular';
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
      }
    }

    .insured-information-container {
      .insured-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .payer-information-container {
      .payer-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .beneficiary-information-container {
      .beneficiary-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .staff-information-container {
      .staff-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .insurance-package-information-container {
      .insurance-package-information {
        display: grid;
        grid-gap: 20px;
        grid-template-columns: 1.5fr 2fr;
      }
    }

    .insurance-premium-information {
      align-items: center;
      background-color: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 3px;
      box-shadow: 0 4px 20px 0 rgba(52, 73, 94, 0.2);
      display: flex;
      margin-bottom: 32px;
      justify-content: space-between;
      padding: 24px;

      .information-name {
        font-family: 'psl_kanda_extraregular';
        font-size: 16px;
        line-height: 24px;
      }

      .information-value {
        color: #27ae60;
        font-family: 'psl_kanda_extraregular';
        font-size: 18px;
        line-height: 24px;
        text-align: right;
      }
    }

    .quotation-confirmation-button-container {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
